import { CompanyData } from './company-data';

export interface User {
  id: string;
  company: {
    id: string;
    name: string;
  };
  visibilityTree: string;
  active: boolean;
  agreedEULA: boolean;
  hideGuide: boolean;
  created: string;
  email: string;
  passwordLifetime: number;
  profile: UserProfile;
  notifications: {
    showSideNotifications: boolean;
  };
  menuState: number;
  maintenanceSettings: {
    startDate: Date | null;
    endDate: Date | null;
  };
  warnings: {
    epsInstalledOnSve: {
      enabled: boolean;
    };
    disableObsoleteTLS: {
      enabled: boolean;
    };
  };
  twoFactorAuthentication: {
    enabled: boolean;
  };
  recordSource: number;
  role: Role;
  source: number;
  userName: string;
  userNameUpperCase: string;
  serviceTargets: ServiceTarget[];
  initStatus: number;
  hideWhatsNew: boolean;
  companyInfo: Partial<CompanyData>;
  hasCGTargets: boolean;
  integrations: unknown[];
  customProperties: unknown[];
  productType: number;
  features: { [key: string]: boolean };
  eventPushService: {
    enabled: boolean;
  };
  mdrSuperAnalyst?: boolean;
}

interface UserProfile {
  fullName: string;
  language: string;
  timezone: string;
  sessionTimeout: number;
  timezoneOffset: string;
  timezoneOffsetSeconds: string;
}

interface Role {
  roleID: string;
  name: string;
  rights: RoleRights;
}

interface RoleRights {
  manageCompanies: boolean;
  manageInventory: boolean,
  managePoliciesRead: boolean,
  managePoliciesWrite: boolean,
  manageUsers: boolean;
  manageReports: boolean;
  companyManager: boolean;
  managePlatform: boolean;
  manageRemoteShell: boolean;
}

interface ServiceTarget {
  serviceID: number;
  targets: Target[];
}

interface Target {
  company: unknown;
  protectedEntityID: string;
  name: string;
  type: number;
  path: string;
}

export namespace User {
  export function doesLoggedUserHaveManageUsersRight(loggedUser: User) {
    return loggedUser.role.rights.manageUsers;
  }
}
